import { CreatePlanDataTypes } from '../OperationalPlanner.types'
import { HorizonInput } from './HorizonInput'

interface ConstrainingHorizonInputsProps {
  createPlanDataObject: CreatePlanDataTypes
  createPlanData: CreatePlanDataTypes
  dispatch: React.Dispatch<any>
  isPlanCreating: boolean
  horizonsSelectionModeState: {
    planHorizon: string
    constrainingHorizon: string
  }
  setHorizonsSelectionModeState: (state: any) => void
  horizonSelectionMode: {
    weeks: string
    date: string
  }
  selectedTemplateKey: string | null
  setIsSelectedVariantEdited: (edited: boolean) => void
}

export const ConstrainingHorizonInputs = (
  props: ConstrainingHorizonInputsProps
) => {
  return (
    <HorizonInput
      horizonType="constraining"
      label="Constraining horizon"
      calendarLabel="C horizon"
      {...props}
    />
  )
}
